import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";
import {jwtDecode} from "jwt-decode";

const TOKEN_KEY = 'auth_token';

export const TokenService = {
    async refreshToken(){
        try{
            const response = await $api.get(`${API_URL}/refresh`);

            if (response?.data){
                localStorage.setItem(TOKEN_KEY, response.data.accessToken);
                return `Bearer ${response.data.accessToken}`;
            }
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },

    saveToken(token){
        localStorage.setItem('token', token);
    },

    getToken(){
        return localStorage.getItem('token');
    },

    getInfoFromToken(){
        const tokenData = localStorage.getItem('auth_token');
        return jwtDecode(tokenData);
    },

    removeToken(){
        localStorage.removeItem(TOKEN_KEY);
    }
};
